<template>
    <div class="flex flex-col gap-2">
        <div class="max-w-full justify-end">
            <Button class="mx-2 my-2" type="danger"
                @click="deleteAccount()" :disabled="deleting">
                {{ $t('profileSection.deleteAccount') }}
            </Button>
            <Loading v-if="deleting"/>  
        </div>
    </div>
</template>

<script setup>
import toastStore from '@/store/toast.store'
import dialogStore from '@/store/dialog.store'
import userStore from '@/store/user.store'
import { appEvents } from '@/store/app.events'
import { isNativePlatform } from '@/utils/capacitor'
import { useRouter } from 'vue-router'
import { ref, defineProps } from 'vue'
import { useI18n } from 'vue-i18n'

const deleting = ref(false)
const { t } = useI18n()
const router = useRouter()

const props = defineProps({
  email: {
    type: String,
    required: true
  }
})

const deleteAccount = async () => { 
  if (!await dialogStore.dispatch('confirm', t('profileSection.confirmDeleteAccount'))) {
    return
  }
  deleting.value = true
  try {
    const response = await fetch('/api/user/delete', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({email: props.email})
    })
    
    if (response.ok) {
      toastStore.dispatch('addMessage', {
        message: t('profileSection.accountDeletedSuccess') || 'Conta excluída com sucesso.',
        icon: 'success'
      })

      // Limpa dados de sessão e cache locais
      try {
        const { clearAllUserCaches } = await import('@/utils/authCleanup')
        await clearAllUserCaches()
        sessionStorage.clear()
        if (isNativePlatform()) {
          try {
            const { Purchases } = await import('@revenuecat/purchases-capacitor')
            await Purchases.logOut().catch(() => null)
          } catch (e) {
            console.warn('[DangerZone] RevenueCat logout error:', e)
          }
        }
      } catch (storageErr) {
        console.warn('[DangerZone] Storage cleanup error:', storageErr)
      }

      userStore.commit('RESET')
      appEvents.emit('app:session-expired')

      setTimeout(() => {
        if (isNativePlatform()) {
          router.replace('/login')
        } else {
          window.location.href = '/login'
        }
      }, 600)
    } else {
      throw new Error('Failed to delete account')
    }
  } catch (err) {
    toastStore.dispatch('addMessage', {
      message: t('profileSection.accountDeletedFailed') || 'Erro ao excluir conta. Tente novamente.',
      icon: 'error'
    })
  } finally {
    deleting.value = false
  }
}
</script> 